export const FeeToleranceCategory = {
  ZERO: 'zero',
  TEN_PERCENT: 'tenPercent',
  UNLIMITED: 'unlimited',
};

export const TOLERANCE_SECTIONS = ['A', 'B', 'C', 'E', 'F'];

export const SECTION_TOLERANCE_CATEGORY = {
  A: FeeToleranceCategory.ZERO,
  B: FeeToleranceCategory.ZERO,
  C: FeeToleranceCategory.TEN_PERCENT,
  E: FeeToleranceCategory.TEN_PERCENT,
  F: FeeToleranceCategory.UNLIMITED,
};

export const TOLERANCE_CHIP_CONFIG = {
  [FeeToleranceCategory.ZERO]: { label: 'Zero', variant: 'error' },
  [FeeToleranceCategory.TEN_PERCENT]: { label: '10% cumulative', variant: 'warning' },
  [FeeToleranceCategory.UNLIMITED]: { label: 'No tolerance limit', variant: 'neutral' },
};

export const TOLERANCE_BUCKET_DESCRIPTION = {
  [FeeToleranceCategory.ZERO]:
    'Cannot increase at closing (0% tolerance). Origination and lender-selected services.',
  [FeeToleranceCategory.TEN_PERCENT]:
    'May increase up to 10% in aggregate. Services the borrower can shop for and recording fees.',
  [FeeToleranceCategory.UNLIMITED]:
    'No tolerance limit — prepaids and escrow can change with actual amounts.',
};
